import { ReportsListModule } from '@/components/modules/Reports/ReportsList/ReportsLists';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_REPORTS_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.REPORTS_LIST,
  schemesByRoles: [
    {
      roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN, APP_ROLES.MERCHANT, APP_ROLES.MERCHANT_GROUP, APP_ROLES.PARTNER],
      titleTextId: 'REPORTS',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <ReportsListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
            ],
          }}
        />
      ),
    },
  ],
};
